// Browsers silently drop control characters while parsing a URL, so a target
// like "/<tab>/host" would reach the address bar as the protocol-relative
// "//host" and leave the store. They are removed before anything is validated.
function stripControlCharacters(value) {
    return Array.from(value)
        .filter((character) => {
            const code = character.charCodeAt(0);

            return code > 31 && code !== 127;
        })
        .join("");
}

// Normalizes a redirect target that came from the URL into a path that can only
// ever point back at this store. Anything able to send the customer somewhere
// else — an absolute URL, a protocol-relative "//host", a "javascript:" scheme —
// collapses to an empty string so the caller falls back to its own default.
function safeRedirectPath(rawPath) {
    if (typeof rawPath !== "string") {
        return "";
    }

    const normalized = stripControlCharacters(rawPath)
        .replace(/\\/g, "/")
        .trim();

    if (!normalized) {
        return "";
    }

    // Protocol-relative URL — same shape as a path, but leaves the origin
    if (normalized.startsWith("//")) {
        return "";
    }

    // Any scheme at all ("https:", "javascript:", "data:") means it is not a path
    if (/^[a-z][a-z0-9+.-]*:/i.test(normalized)) {
        return "";
    }

    return normalized.startsWith("/") ? normalized : `/${normalized}`;
}

export default safeRedirectPath;
